<template>
  <v-sheet class="ma-2">
    <v-dialog width="600" v-model="datesDialog">
      <v-card>
        <v-card-title
          >Choose the date range to view for teacher's attendance</v-card-title
        >
        <v-card-text class="text-center">
          <v-date-picker :max="today" v-model="dates" range></v-date-picker>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-row>
      <v-col cols="12" lg="8">
        <v-text-field
          @click:prepend="datesDialog = true"
          @click="datesDialog = true"
          v-model="dateRangeText"
          label="Date range"
          prepend-icon="mdi-calendar"
          readonly
        ></v-text-field>
      </v-col>
      <v-col cols="12" lg="4">
        <v-select
          v-model="selectedCustomDates"
          :items="customDates"
          item-value="label"
          item-text="label"
          label="Predefined Dates"
        />
      </v-col>
    </v-row>

    <div class="text-subtitle-1 ma-2">Total: {{ totalHours }}</div>

    <div v-if="timesheetRecords && timesheetRecords.length > 0">
      <v-data-table
        :headers="timesheetHeaders"
        :items="timesheetRecords"
        :items-per-page="10"
        class="elevation-1"
      >
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editTimesheetRecord(item)">
            mdi-pencil
          </v-icon>
        </template>
      </v-data-table>
    </div>
    <div v-else>No previous timesheet records found</div>

    <!-- <v-simple-table v-if="report">
      <tbody>
        <tr>
          <td>Sessions</td>
          <td>{{ report.total_sessions_attended }}</td>
        </tr>
        <tr>
          <td>Sessions Absent</td>
          <td>{{ report.total_sessions_absent }}</td>
        </tr>
        <tr>
          <td>Hours</td>
          <td>{{ report.total_hours }}</td>
        </tr>
      </tbody>
    </v-simple-table> -->
  </v-sheet>
</template>

<script>
import moment from "moment";

export default {
  props: {
    teacher: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    dates: [],
    datesDialog: false,
    customDates: [],
    selectedCustomDates: null,
    report: null,
    timesheetHeaders: [
      { text: "Date", value: "date", sortable: false },
      { text: "Time In", value: "timeIn", sortable: false },
      { text: "Time Out", value: "timeOut", sortable: false },
      { text: "Length", value: "length", sortable: false },
      { text: "Comments", value: "notes", sortable: false },
      { text: "Actions", value: "actions", sortable: false }
    ],
    timesheetRecords: [],
    totalHours: "",
    today: new Date().toString()
  }),
  computed: {
    dateRangeText() {
      if (this.dates && this.dates.length != 2) {
        return "Choose a date range";
      } else {
        console.log(this.dates);
        const momentDates = this.dates.map(d => moment(d));
        const sortedDates = momentDates.sort(
          (a, b) => a.valueOf() - b.valueOf()
        );
        // const sortedDates = this.dates.sort((a, b) => moment(b).isAfter(moment(a)))
        return sortedDates.map(d => d.format("dddd, MMMM DD YYYY")).join(" ~ ");
      }
    }
  },
  watch: {
    dates(newDates) {
      if (newDates && newDates.length == 2) {
        console.log("date range changed");
        console.log(newDates);
        // this.queryAttendance();
        this.getTimesheetRecords().then(records => {
          this.timesheetRecords = records;
        });
      }
    },
    teacher(t) {
      console.log("teacher changed, querying attendance: " + t);
      // this.queryAttendance();
      this.getTimesheetRecords().then(records => {
        this.timesheetRecords = records;
      });
    },
    selectedCustomDates(label) {
      if (label) {
        const predefined = this.customDates.find(c => c.label == label);
        this.dates = [predefined.start, predefined.end];
      }
    }
  },
  mounted() {
    this.initDates();
  },
  methods: {
    queryAttendance() {
      //check preconditions
      if (
        this.dates &&
        this.dates.length == 2 &&
        this.teacher &&
        this.teacher.id
      ) {
        const params = {
          startDate: this.dates[0],
          endDate: this.dates[1],
          teacherId: this.teacher.id
        };
        this.$axios.get("/report/teacher/attendance", { params }).then(resp => {
          this.report = resp.data;
        });
      }
    },
    initDates() {
      const startOfMonth = moment()
        .startOf("month")
        .format("YYYY-MM-DD");
      const endOfMonth = moment()
        .endOf("month")
        .format("YYYY-MM-DD");
      this.dates = [startOfMonth, endOfMonth];

      const dateOptions = [];
      const lastMonth = moment().subtract(1, "months");
      dateOptions.push({
        label: "Last Month",
        start: lastMonth.startOf("month").format("YYYY-MM-DD"),
        end: lastMonth.endOf("month").format("YYYY-MM-DD")
      });
      dateOptions.push({
        label: "Current Month",
        start: startOfMonth,
        end: endOfMonth
      });

      const lastWeek = moment().subtract(1, "week");
      dateOptions.push({
        label: "Last Week",
        start: lastWeek.startOf("week").format("YYYY-MM-DD"),
        end: lastWeek.endOf("week").format("YYYY-MM-DD")
      });
      dateOptions.push({
        label: "Current Week",
        start: moment()
          .startOf("week")
          .format("YYYY-MM-DD"),
        end: moment()
          .endOf("week")
          .format("YYYY-MM-DD")
      });

      this.customDates = dateOptions;
    },
    async getTimesheetRecords() {
      const params = {
        staff_id: this.teacher.id,
        staff_type: "teacher",
        start_date: this.dates[0],
        end_date: this.dates[1]
      };
      return await this.$axios
        .get("/timesheet/get-by-staff", { params })
        .then(resp => {
          const records = resp.data;
          let totalMinutes = 0;

          // add a date field to each record
          const formattedRecords = records.map(r => {
            const minutes = moment(r.timeOut).diff(moment(r.timeIn), "minutes");
            totalMinutes += minutes;
            r.length = minutes ? `${(minutes / 60).toFixed(2)} hours` : "-";

            const timeOut = moment(r.timeOut);
            r.date = moment(r.timeIn).format("ddd, MMM DD yyyy");
            r.timeIn = moment(r.timeIn).format("hh:mm a");
            r.timeOut = r.timeOut ? timeOut.format("hh:mm a") : "-";

            return r;
          });

          this.totalHours = `${(totalMinutes / 60).toFixed(2)} hours`;

          return formattedRecords;
        });
    },
    editTimesheetRecord(record) {
      console.log("edit record: ", record);
      this.$router.push({name: 'TeacherTimeRecord', params: {id: record.id, teacherId: this.teacher.id}})
    }
  }
};
</script>

<style></style>
